import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { store } from 'store';
import { closeRightSidebar } from 'store/slices/dual-sidebar';
import { LAYOUT_ZOOM_CHAT_CENTER_COLLAPSE_RIGHT_BELOW_PX } from './layout-zoom-constants';

/** כשאזור הצ'אט המרכזי צר מדי — סוגרים את הפאנל הימני כדי למנוע חניקה (מסונכרן ל־layout-zoom-constants). */
export function useCollapseRightWhenChatNarrow(mainInnerEl: HTMLElement | null): void {
  const { pathname } = useLocation();

  useEffect(() => {
    if (!mainInnerEl || !pathname.startsWith('/chats')) return;

    const ro = new ResizeObserver((entries) => {
      const w = entries[0]?.contentRect.width ?? 0;
      if (w <= 0 || w >= LAYOUT_ZOOM_CHAT_CENTER_COLLAPSE_RIGHT_BELOW_PX) return;
      if (store.getState().dualSidebar.right.open) {
        closeRightSidebar();
      }
    });

    ro.observe(mainInnerEl);
    return () => ro.disconnect();
  }, [mainInnerEl, pathname]);
}
